import React from "react";
import Button, { ButtonProps } from "../Button";
import { FabContainer, FabDefaultStyles, FabStyles } from "./FabStyles";

export type ButtonStylesOverrides = {
  bottom?: number;
  right?: number;
};

type FabProps = ButtonProps & {
  fabStyles?: ButtonStylesOverrides;
};

const Fab: React.FC<FabProps> = ({ children, fabStyles = {}, ...rest }) => {
  const StylesOverrides: FabStyles = { ...FabDefaultStyles, ...fabStyles };
  return (
    <FabContainer styles={StylesOverrides}>
      <Button {...rest}>{children}</Button>
    </FabContainer>
  );
};

export default Fab;
